/**
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

export { default as TreeViewDefault } from './treeview-default.story';
export { default as TreeViewCustom } from './treeview-custom.story';
export { default as TreeViewSkeletonLoading } from './treeview-skeleton-loading.story';

import { removeLicenseHeader } from '../../_common/export-stories-utils';
import TreeViewCustomSourceRaw from './treeview-custom.story?raw';
import TreeViewDefaultSourceRaw from './treeview-default.story?raw';
import TreeViewSkeletonLoadingSourceRaw from './treeview-skeleton-loading.story?raw';

export const TreeViewDefaultSource = removeLicenseHeader(
  TreeViewDefaultSourceRaw,
);
export const TreeViewCustomSource = removeLicenseHeader(
  TreeViewCustomSourceRaw,
);
export const TreeViewSkeletonLoadingSource = removeLicenseHeader(
  TreeViewSkeletonLoadingSourceRaw,
);
